module.exports = __webpack_public_path__ + "img/6.e40de8f2.jpg";